// angular import
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

// project import
import { SharedModule } from 'src/app/@core/shared/shared.module';
import { VERSION } from 'src/environments/version';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-footer',
  imports: [CommonModule, SharedModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  version = VERSION;
  currentDate: Date = new Date();
  tickets = environment.ticketsurl

}
